import { FileCopy } from '@material-ui/icons';
import { downloadFile } from 'Utils';
import Grid from '@material-ui/core/Grid';
import React from 'react';

import FileDownload from '../components/FileDownload';
import Wrapper from '../components/Wrapper';
import HiddenLink from '../components/HiddenLink';
import CustomArrowDown from '../components/CustomArrowDown';

class IesFile extends React.Component {
  link = React.createRef();
  state = {
    error: null,
  };

  componentDidCatch(error, info) {
    this.setState({
      error,
    });
  }

  onDownloadError = error => {
    this.setState({
      error,
    });
  };

  onDownloadFile = downloadFile;

  render() {
    if (!this.props.ies) return null;
    return (
      <Grid item xs={12} className="u-pad-top-10 u-pad-bot-10">
        <Grid container>
          <Grid item xs={6} className="">
            <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
              Photometric data or CAD file
            </h2>
          </Grid>
          {this.props.ies && (
            <Grid container className="t-primary-14 c-gray-light">
              <Wrapper>
                <FileCopy />
                <HiddenLink
                  innerRef={this.link}
                  download={this.props.ies.originalName}
                />
                <FileDownload
                  onClick={this.onDownloadFile(
                    this.props.ies.assetId,
                    this.link
                  )(this.onDownloadError)}
                >
                  {this.props.ies.originalName}
                </FileDownload>
                <CustomArrowDown />
              </Wrapper>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }

  static defaultProps = {
    ies: {
      assetId: null,
      originalName: null,
    },
  };
}

export default IesFile;
